import "./cookie-bar.component.scss";

export default {
  template: require('./cookie-bar.component.html'),
  controller: function (vuiLocalStorage) {

    'ngInject';

    const self = this;
    const STORED_KEY = 'accept-cookies-policy';

    self.showMessage = !vuiLocalStorage.get(STORED_KEY, false);

    self.gotIt = () => {
      self.showMessage = false;
      vuiLocalStorage.put(STORED_KEY, !self.showMessage);
    };

  }
};
